






















import Vue from 'vue'
import Component from 'vue-class-component'
import { auth } from 'firebase/app'

@Component
export default class Navbar extends Vue {
  get user () {
    return auth().currentUser
  }

  async logout () {
    await auth().signOut()
    await this.$router.replace('/login')
  }
}
